<template>
    <base-modal
        :ref="modal.key"
        :show="open"
        maxWidth="800"
        :title="modal.title"
        @on-confirm="saveItem"
        @on-cancel="hide()"
        :okText="$t('Save')"
        :closeText="$t('Close')"
        class="link-document-modal"
    >
        <v-form class="mt-5 mb-0 pt-0">
            <v-row>
                <v-col cols="10">
                    <v-text-field
                        v-model="docsToBeLinked"
                        v-bind:label="$t('Site.LinkedDocuments.Titles.LinkInput')"
                    />
                </v-col>
                <v-col cols="2">
                    <v-btn
                        color="primary"
                        class="mt-5 add-link_button"
                        small
                        @click="addLink"
                        >{{ $t("Add") }}</v-btn
                    >
                </v-col>
            </v-row>
        </v-form>
        <v-simple-table
            height="250px"
            class="mb-2"
            v-if="linkedDocuments.length > 0"
        >
            <template v-slot:default>
                <thead>
                    <tr>
                        <th
                            class="text-left m-0 p-0 linked-document_table"
                            style="width: 25%"
                        >
                            {{ $t('Site.LinkedDocuments.Titles.DocumentsToBeLinked') }}
                        </th>
                        <th class="text-left m-0 p-0 linked-document_table">
                            {{ $t("Description") }}
                        </th>
                        <th
                            class="text-right m-0 p-0 linked-document_table"
                            style="width: 15%"
                        >
                            {{ $t("Actions") }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="(linkedDoc, index) in linkedDocuments"
                        :key="linkedDoc.documentId"
                    >
                        <td>{{ linkedDoc.linkedDocumentId }}</td>
                        <td>
                            <v-text-field
                                class="mt-4 description-text-field"
                                dense
                                v-model="linkedDoc.description"
                                :error-messages="descriptionErrors(index)"
                                v-bind:label="$t('Description')"
                                :maxLength="200"
                                @input="$v.linkedDocuments.$each[index].description.$touch()"
                                @blur="$v.linkedDocuments.$each[index].description.$touch()"
                            />
                        </td>
                        <td class="text-right">
                            <v-btn color="red" small @click="remove(index)"
                                ><v-icon icon>mdi-delete</v-icon></v-btn
                            >
                        </td>
                    </tr>
                </tbody>
            </template>
        </v-simple-table>
    </base-modal>
</template>
<script>
import { required } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import Utils from '@/ecm/common/Utils';
import LinkedDocumentService from '@/services/LinkedDocumentService';
export default {
    name: 'LinkDocumentModal',
    components: {},
    computed: {
        modalInstance() {
            return this.$refs[this.modal.key];
        },
        descriptionErrors() {
            return (index) => {
                const errors = [];
                const validation = this.$v.linkedDocuments.$each[index].description;
                if (validation) {
                    if (!validation.$dirty) return errors;
                    if (!validation.required) errors.push(this.$t('RequiredField'));
                }
                return errors;
            };
        }
    },
    data() {
        return {
            mainDocumentId: null,
            linkedDocuments: [],
            open: false,
            modal: {
                title: this.$t('Site.LinkedDocuments.Titles.LinkDocuments'),
                key: 'linkDocumentModal',
            },
            docsToBeLinked: '',
        };
    },
    mixins: [validationMixin],
    validations: {
        linkedDocuments: {
            required,
            $each: {
                description: {
                    required
                }
            }
        },
    },
    methods: {
        show() {
            this.open = true;
        },
        hide() {
            this.$v.linkedDocuments.$reset();
            this.linkedDocuments = [];
            this.docsToBeLinked = '';
            this.mainDocumentId = null;
            this.open = false;
        },
        remove(index) {
            this.linkedDocuments.splice(index, 1);
        },
        saveItem() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            }

            this.modalInstance.progress(true);
            LinkedDocumentService.save(
                this.mainDocumentId,
                this.linkedDocuments
            )
                .then((result) => {
                    if (result) {
                        this.hide();
                        Utils.toast.success(
                            this.$t('Site.LinkedDocuments.Messages.LinkSuccess')
                        );
                        this.$emit('on-linked-document-saved');
                    }
                })
                .catch(() => {})
                .then(() => {
                    this.modalInstance.progress(false);
                });
        },
        new(mainDocumentId) {
            this.mainDocumentId = mainDocumentId;
            this.$v.$reset();
            this.show();
        },
        addLink() {
            try {
                const ids = this.extractIds(this.docsToBeLinked);
                ids.forEach((linkedDocId) => {
                    const existingDoc = this.linkedDocuments.find(
                        (doc) => doc.linkedDocumentId === linkedDocId
                    );
                    if (!existingDoc) {
                        const linkedDoc = {
                            linkedDocumentId: linkedDocId,
                            description: '',
                        };
                        this.linkedDocuments.push(linkedDoc);
                        this.docsToBeLinked = '';
                    }
                });
            } catch (error) {
                Utils.toast.error(error.message);
            }
        },
        extractIds(input) {
            const value = input.replaceAll(' ', '');
            const urlPattern = /document-ids\/([0-9,]+)/;
            const idPattern = /^\d+$/;

            if (urlPattern.test(value)) {
                // Extraer IDs de la URL
                const match = value.match(urlPattern);
                if (match && match[1]) {
                    return match[1].split(',').map((id) => parseInt(id, 10));
                }
            } else if (idPattern.test(value)) {
                // Extraer un solo ID si el input es un número suelto
                return [parseInt(value, 10)];
            }
            throw new Error(this.$t('Site.LinkedDocuments.Messages.InvalidInput'));
        },
    },
};
</script>
<style lang="scss">
.link-document-modal {
    table {
        line-height: 4;
    }
    .v-text-field__details {
        display: none !important;
        position: absolute !important;
    }
}
.linked-document_table {
    font-weight: 600 !important;
    font-size: 12px !important;
    height: 50% !important;
    padding-bottom: 5px !important;
}
.add-link_button {
    width: 100%;
    font-size: 11px;
}
</style>